import CircularProgress from "@material-ui/core/esm/CircularProgress";
import Box from "@material-ui/core/esm/Box";
import clsx from 'clsx';
import { nanoid } from 'nanoid';
import React from 'react';
import useStyles from './SpinnerStyles';
export default function Spinner({
  size,
  isButtonProgress,
  isWhiteSpinner,
  isAutocompleteSpinner
}) {
  const id = nanoid();
  const spinnerId = `Spinner ${id}`;
  const {
    spinnerRoot,
    autocomplete,
    buttonProgress,
    white
  } = useStyles();
  if (isButtonProgress || isAutocompleteSpinner) {
    return /*#__PURE__*/React.createElement(Box, {
      "aria-labelledby": spinnerId
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      id: spinnerId,
      "aria-label": spinnerId,
      size: size,
      className: clsx({
        [buttonProgress]: isButtonProgress,
        [autocomplete]: isAutocompleteSpinner,
        [white]: isWhiteSpinner
      })
    }));
  }
  return /*#__PURE__*/React.createElement(Box, {
    "aria-describedby": spinnerId,
    className: spinnerRoot
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    id: spinnerId,
    "aria-label": spinnerId,
    className: isWhiteSpinner ? white : ''
  }));
}
Spinner.defaultProps = {
  isAutocompleteSpinner: false,
  isButtonProgress: false,
  isWhiteSpinner: false,
  size: 16
};